import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store";
import styles from "./MoreInfo.module.css";
import PopUpModal from "../PopUpModal/PopUpModal";
import FormInput from "../FormInput/FormInput";
import FormTextarea from "../FormTextarea/FormTextarea";

export default function MoreInfoModal() {
    const dispatch = useDispatch();
    const [formValidity, setFormValidity] = useState({});

    const moreInfoModalStatus = useSelector((state) => state.ui.moreInfoModalActive);

    const checkFormValidity = () => {
        for (let key in formValidity) {
            if (!formValidity[key]) {
                document.getElementById(key).focus();
                document.getElementById(key).blur();
                return false;
            }
        }
        return true;
    };

    const handleClose = () => {
        dispatch(uiActions.setMoreInfoModalStatus(false));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(checkFormValidity()){
            const data = new FormData(event.target);
            const dataObj = data.entries();
            const formData = {};
            dataObj.forEach((arry, key) => {
                formData[arry[0]] = arry[1]
            });

            formData['toEmail'] = 'info@cambridgehomes.com';
            formData['body'] = `More info inquiry message:${formData['body']}`;

            console.log(formData)
            try {
                const response = await fetch('/services/email.ashx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded' // Ensure correct content type
                    },
                    body: new URLSearchParams(formData)
                });

                if (response.ok) {
                    // Handle success
                    console.log('Form submitted successfully');
                    console.log(response);
                    handleClose();
                } else {
                    // Handle error
                    console.error('Form submission failed');
                }
            } catch (error) {
                console.error('Error submitting form:', error);
            }
        }
    };

    return (
        <>
            {moreInfoModalStatus &&
                <PopUpModal handleClose={handleClose}>
                    <div className={styles.container}>
                        <h1>Get More Information</h1>
                        <p>Have more questions about your design or Cambridge Homes? We'd love to help! Please provide your name and email, and we'll get in touch with you shortly.</p>
                        <form onSubmit={handleSubmit}>
                            <div className={styles.flexDiv}>
                                <FormInput
                                    id="fromName"
                                    name="fromName"
                                    label="Name"
                                    type="text"
                                    required={true}
                                    errorMsg={"Only letters and spaces allowed"}
                                    pattern={/^[A-Za-z\s]+$/}
                                    setFormValidity={setFormValidity}
                                />
                                <FormInput
                                    id="email"
                                    name="fromEmail"
                                    label="Email Address"
                                    type="email"
                                    required={true}
                                    errorMsg={"Enter valid email address. ex - someone@example.com"}
                                    pattern={/^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/}
                                    setFormValidity={setFormValidity}
                                />
                            </div>
                            <FormTextarea
                                id="message"
                                name="body"
                                label="Message"
                                defaultText=""
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/.*/}
                                setFormValidity={setFormValidity}
                            />
                            <button type="submit">Request more information</button>
                        </form>
                    </div>
                </PopUpModal>
            }
        </>
    );
}

export {MoreInfoModal};
